import React from 'react'

function Footer() {
    return (
        <footer className="relative bottom-0 bg-[#393E46] text-white w-full text-center py-2 mt-8">
            <div className="text-md font-semibold">
                made with <span className='text-red-500'>&hearts;</span> by Jagnyasai, Navneet, Amrutanshu, Sudhanshu !!
            </div >
        </footer>
    )
}

export default Footer